module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"deleteCurrentData":"Bestehende Daten löschen","file":"Datei","upload":"Hochladen"},"en":{"deleteCurrentData":"Delete current data","file":"File","upload":"Upload"}}')
  delete Component.options._Ctor
}
